import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import MerchantBrandRegexRuleModal from './Modals/MerchantBrandRegexRuleModal'
import CommonRuleActionsCell from './../Common/CommonRuleActionsCell'

import { MerchantBrandRegexRulesActions } from './../actions'

class MerchantBrandRegexActionsCell extends Component {
  deleteFunction = id => {
    this.props.saveRuleAction({ id, isActive: false })
  }

  activateFunction = id => {
    this.props.saveRuleAction({ id, isActive: true })
  }

  getEditModal = () => {
    const {
      id,
      merchantId,
      merchantName,
      brandId,
      brandFullPath,
      includeParam,
      excludeParam,
      ruleType,
      isExcludeRule
    } = this.props.row
    const { saveRuleAction } = this.props
    return (
      <MerchantBrandRegexRuleModal
        value={{
          id,
          brandId,
          brandFullPath,
          merchantId,
          merchantName,
          includeParam,
          excludeParam,
          ruleType,
          isExcludeRule
        }}
        onOkHandler={saveRuleAction}
      />
    )
  }

  render() {
    const { id, isActive, merchantIsActive, brandIsActive, ruleIsActive } = this.props.row
    let activationTooltip = ''
    let isActivationBlocked = false

    if (isActive) {
      activationTooltip = 'Delete rule'
    } else if (!merchantIsActive) {
      activationTooltip = "Can't reactivate because related Merchant is inactivate"
      isActivationBlocked = true
    } else if (!brandIsActive) {
      activationTooltip = "Can't reactivate because related Brand is inactivate"
      isActivationBlocked = true
    } else if (!ruleIsActive && merchantIsActive && brandIsActive) {
      activationTooltip = 'Re-Activate'
    }

    return (
      <CommonRuleActionsCell
        editModaTitle="Edit Merchant Brand Regex Rule (MCRR)"
        editModalContent={this.getEditModal()}
        id={id}
        isActive={isActive}
        isActivationBlocked={isActivationBlocked}
        activationTooltip={activationTooltip}
        deleteFunction={this.deleteFunction}
        activateFunction={this.activateFunction}
      />
    )
  }
}

MerchantBrandRegexActionsCell.propTypes = {
  saveRuleAction: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired
}

const mapDispatchToProps = {
  saveRuleAction: MerchantBrandRegexRulesActions.save
}

export default connect(null, mapDispatchToProps)(MerchantBrandRegexActionsCell)
